//=============================================================================
// app modules
//=============================================================================

//=============================================================================

import utilityModule from "./utility/module";

/*
Dummy API - 
* some dynamic features - 
* search - legacy 
* basket - legacy
* activities - legacy
* locations - legacy
* more...
*/
import dummies from "./dummies/module"; // useful, dynamic

/**
 * App
 */

import interceptors from "./interceptors/module";
import modules from "./modules/module";
import pages from "./pages/module";

/**
 * TO DO ::: LOW ::: Refactor
 */
import components from "./components/module"; // refactor - move to modules..
import services from "./services/module"; //  refactor to modules - adios :-)
import factories from "./factories/module"; //  refactor to modules - adios :-)
import forms from "./forms/module"; // refactor to modules

const modul = angular.module("appModule", [
    utilityModule,
    dummies,
    interceptors,
    modules,
    services,
    factories,
    pages,
    components,
    forms,
]);

export default modul.name;
